import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  Button,
  Center,
  Flex,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

const UnlockOfferMessageModal = ({ show, onClose }) => {
  // Redux

  const closeModal = () => {
    onClose()
  }

  const handleRefresh = () => {
    window.location.reload()
  }
  return (
    <Modal isOpen={show} onClose={closeModal} size="xl" scrollBehavior={'inside'}>
      <ModalOverlay />
      <ModalContent maxW="50%">
        <ModalHeader>
          <Center>
            <Heading>Offer Unlocked</Heading>
          </Center>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex justifyContent={'center'}>
            Previous user has left the offer. You may edit now. Please refresh to see previous user&apos;s changes
          </Flex>
        </ModalBody>

        <ModalFooter>
          <Flex gap="3">
            <Button colorScheme="teal" onClick={handleRefresh}>
              Refresh
            </Button>
            <Button colorScheme="gray" onClick={closeModal}>
              Close
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default UnlockOfferMessageModal
